import { Component, OnInit, Input, inject } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalController } from '@ionic/angular';
import { ExercisemodalComponent } from '../../components/exercisemodal/exercisemodal.component'

@Component({
    selector: 'app-exercisebutton',
    templateUrl: './exercisebutton.component.html',
    styleUrls: ['./exercisebutton.component.scss'],
    standalone: false
})
export class ExercisebuttonComponent implements OnInit {
  @Input() exercise: any;

  private api = inject(ApiService);

  constructor(public modalController:ModalController, public data: DataService) {
  }

  ngOnInit() {
    console.log(" ngOnInit this.exercise.thumb " + this.exercise.id)
  }

  select_(){
    console.log(this.video)
  }

  get video(){
    return this.exercise.video;
  }

  reseter(exercise){
    console.log("reseter");
    // console.log(this.exercise.current.id+'-1');
    // this.exercise = exercise;
    // console.log(this.exercise.current.id+'-2');
    // this.data.refreshRecovery().then((response) => {
    //   console.log('done reseter')
    // })
    // this.data.pullAppContent(['endpoint']).then(() => {
    //   this.data.pullAppContent(['smodules']);
    // });
  }

  async select(){
    let that = this
    const modal = await this.modalController.create({
      component: ExercisemodalComponent,
      animated: true,
      cssClass: 'exercise-modal-shell',
      htmlAttributes: { 'aria-label': 'Video: ' + (that.video?.title || '') },
      componentProps: {
        video: that.video,
        exercise: that.exercise,
        reseter: this.reseter,
        basepath: that.api.getMediaBase()
      }
    });

    this.data.setEventsAnalytics('Open Exercise ' + this.exercise.id, 'event', {
      exercise_id: this.exercise.id,
      video_id: this.video ? this.video.id : '',
      level: this.exercise.getCurrentLevel
    });

    return await modal.present();
  }

   thumbpath(){
    if(this.exercise.thumb)
      return encodeURI(this.api.mediaUrl(this.exercise.thumb));
    else
      return encodeURI(this.api.mediaUrl(this.video.thumb));
  }
}